import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import Input from '../../../shared/form-elements/input';

lessRequire('modules/statistics/components/save-export/suggest-form.less');

const Form = ({
	handleSubmit,
	data,
	onApply,
	onSave,
	onExport,
	onToggle,
	intl
}) =>
	<form className="save-filters-form" onSubmit={handleSubmit(formData => onSave(formData))}>
		<div className="save-filters-form__items">
			{data && items(data, onApply)}
		</div>

		<div className="save-filters-form__element">
			<Field name="title" component={Input} placeholder={intl('Или сохранить как...')} />
		</div>

		<div className="save-filters-form__btn">
			<button className="button white-bg yellow-border font-proxima-nova-semibold">{intl('Сохранить')}</button>
		</div>

		<div className="save-filters-form__exports">
			<span className="label">{intl('Export')}</span>
			<div className="methods">
				<a
					href="javascript:;"
					onClick={() => {
						onExport();
						onToggle();
					}}>{intl('CSV')}</a>
			</div>
		</div>

	</form>;

const items = (data, onApply) =>
	data.map(item =>
		<a
			key={item.id}
			href="#"
			onClick={e => {
				e.preventDefault();
				onApply(item.id);
			}}
		>
			{item.title}
		</a>
	);

Form.propTypes = {
	handleSubmit: PropTypes.func,
	data: PropTypes.array,
	onApply: PropTypes.func,
	onSave: PropTypes.func,
	onExport: PropTypes.func,
	onToggle: PropTypes.func,
	intl: PropTypes.func
};

export default reduxForm({
	form: 'saveFiltersForm'
})(Form);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/components/save-export/suggest-form.js